// extracted by mini-css-extract-plugin
export default {"Logo":"Logo_Logo__7Hb28"};